export const handleAlertOpenChange = (handleClose, data) => {
  if (!data.open) handleClose?.();
};
